import { Button, Modal } from "react-bootstrap";
import { LuX } from "react-icons/lu";

/**
 * Confirmation modal for passkey deletion
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether modal is visible
 * @param {Object} props.passkey - Passkey object to delete
 * @param {Function} props.onConfirm - Callback when user confirms deletion
 * @param {Function} props.onCancel - Callback when user cancels deletion
 * @returns {JSX.Element} Rendered confirmation modal
 */
const GenericModal = ({ show, title, body, confirmText, cancelText, onConfirm, onCancel }) => {
  return (
    <Modal show={show} onHide={onCancel} centered contentClassName="delete-modal">
      <button onClick={onCancel} className="position-absolute right-0 top-0 btn"><LuX size={28} /></button>
      <Modal.Body>
         <h5 className="text-center mb-3">{title}</h5>
        <div className="mb-3">
        {
          body?.split('\n').map((p, i) => (<p key={i}>{p}</p>))
        }
        </div>
        <Button
          variant="warning"
          className="racq-primary-btn w-100 mb-3 mt-4"
          onClick={onConfirm}
        >
          <b>{confirmText}</b>
        </Button>
        <Button variant="outline" className="w-100 racq-secondary-btn" onClick={onCancel}>
          <b>{cancelText || 'Cancel'}</b>
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default GenericModal;
